export default "<ion-content>\n\t<ion-row class=\"center\">\n\t\t<ion-spinner></ion-spinner>\n\t</ion-row>\n</ion-content>\n";